module.exports = __webpack_public_path__ + "img/heart_1.0241b9e6.png";